
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Classical Vocal </h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm kalyani-deshpande section-banner-bg-1">
    <div class="container">
        <div class="sec-title text-center">
            <h2>Melodies <span > Of The Strings...</span></h2>
            <p>Light and classical colors of music</p>
            <p>By</p>
            <p>Ms. Kalyani Deshpande</p>
            <p>(A promising upcoming sitarist from Pune)</p>
        </div>
        <div class="row mt-5">
            <div class="col-lg-8">
                <div class=" text-justify">
                    <h2 class="head-lea">MS. KALYANI DESHPANDE <span class="small-sm">25 JULY 2020 </span></h2>
                    <p>Kalyani Deshpande is promising upcoming sitarist form Pune. Kalyani was born into a family of
                        musicians and was introduce to Hindustani Classical Music at a very young age by her grandfather
                        who used to learn music from Pd. Bhimsen Joshi.</p>
                    <p>Kalyani started taking lessons of Indian classical music from her parents, Shri. Shridhar
                        Deshpande (Tabla player of Banaras Gharana) and Smt. Vandana Deshpande and her elder sister Neha
                        Deshpande (professional Indian classical vocalist). By the time the pure and ethnic sound of
                        sitar attracted Kalyani and made her mind to learn sitar.</p>
                    <p>It was her fortune to receive sitar as a gift in the form of blessings from her grand uncle
                        Dr.Shri. Arvind Joshi. Her formal sitar learning began under Smt. Leela Tai Kanade (Discple of
                        U.Abdul Karim khan). Kalyani is now taking taalim (training) under her guru Shri. Chandrshekhar
                        Rande himself disciple of U.Shahid Parvez Khan. The gayki ang and the beauty of raag rendition
                        is one of the characteristics of Etava gharana which has been conveyed from her guru to her.</p>
                </div>
                <div class="col-lg-12">
                    <p>Apart from her taalim Kalyani got opportunity to learn and take guidance from Pd. Smt. Sandhya
                        Apte. (maihar gharana). Though Kalyani started learning sitar at the age of 13, her love,
                        dedication and humble efforts for her passion making her one step closer to the perfection. Now
                        a day Kalyani performs Indian classical and semi classical music (sitar vadan) solo as well as
                        duet.</p>
                </div>
            </div>

            <div class="col-md-4">
                <div class="image-effect-3">
                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/kalyani-deshpande.webp"
                        alt="GHRSCF">
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-12">
                <div class="">
                    <h6 class="fw-bold">QUALIFICATION</h6>
                    <ul class="list-style list-style1">
                        <li>Double degree in microbiology and chemistry</li>
                        <li>Masters in Music (sitar specialization) with a grade</li>
                    </ul>

                    <h6 class="fw-bold mt-3">ACHIEVEMENTS</h6>
                    <ul class="list-style list-style1">
                        <li>Spic Macay scholarship Opportunity to learn in renowned music institute ITCSRA, Kolkata.
                        </li>
                        <li>National Youth festival performer (2014)</li>
                        <li>Second prize in Shri. Shandmukhananda National level music competition, Mumbai (2015)
                            Honored to receive prize from Padma Bhushan Shri. T.V.Shankarnarayan</li>
                        <li>Award of ‘Best Instrumentalist’ in Firodia Karandak. (2011)</li>
                    </ul>
                    <h6 class="fw-bold mt-3">CONCERTS</h6>
                    <p>Upashi Vithoba music festival, Pune. Milaap music festival of instruments and vocalist, Pune
                        Performances in Ardra –Fusion Band Private Concerts and maifil.</p>
                    <h6 class="fw-bold mt-3">MUSICAL WORK </h6>
                    <p>Teaching sitar for past 3 years one to one as well as online (Skype) tuitions</p>
                    <p>Lecture- Demo, Workshops and Seminars in Schools</p>
                    <p>Studio work for light music pieces.</p>
                </div>
            </div>
        </div>

        <div class="border-line-sm"></div>
        <div class="row">
            <div class="col-lg-8">

                <h6 class="fw-bold">LET’S MEET THEN.</h6>
                <h6 class="fw-bold">G.H.RAISONI SPORTS & CULTURAL FOUNDATION ORGANIZES-ONLINE SESSION</h6>
                <h6 class="fw-bold">TOPIC : MELODIES OF THE STRINGS... LIGHT AND CLASSICAL COLURES OF MUSIC</h6>
                <p>Speaker: Ms. Kalyani Deshpande (A promising upcoming sitarist from Pune)</p>
                <p>Date : Saturday, 25<sup>th</sup> July 2020</p>
                <p>Time : 7:30 Pm</p>
                <p>Venue : Your Home at your Mobile</p>

                <h6 class="fw-bold">NOTE - LOGIN TO YOUR FACEBOOK ACCOUNTS 10 MINS BEFORE THE SESSION</h6>
                <p>Link: <a href="https://facebook.com/sgrkf/live" target="_blank">https://facebook.com/sgrkf/live</a>
                </p>

            </div>
            <div class="col-md-4">
                <div class="image-effect-3">
                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/online-invitation-kalyani.webp"
                        alt="GHRSCF">
                </div>
            </div>
        </div>

        <div class="border-line-sm"></div>

        <div class="row">
            <div class="col-lg-6">
                <div class="gall-ery">
                    <div class="row">
                        <div class="col-md-4">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h6 class="fw-bold">QUALIFICATION</h6>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <a href="videogallery" target="_blank" class="btn button--effect-1"><span>
                                    YouTube link</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                            </a>
                        </div>
                        <div class="col-md-4">
                            <a href="videogallery" target="_blank" class="btn button--effect-1"><span>
                                    YouTube link</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                            </a>
                        </div>
                    </div>
                    <iframe width="100%" height="230" src="https://www.youtube.com/embed/v0LJ2w-3UcQ" frameborder="0"
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen></iframe>
                </div>
            </div>

        </div>

    </div>
</section>
